var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFiles = function SvgFiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#10A2FC",
    clipPath: "url(#clip-path-files)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.77 35.38H5V3.1h8.77v32.28Zm-7.77-1h6.77V4.1H6v30.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.97 7.66H7.81v1h3.16v-1Zm0 3.03H7.81v1h3.16v-1Zm10.57 24.69h-8.77V3.1h8.77v32.28Zm-7.77-1h6.77V4.1h-6.77v30.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.74 7.66h-3.16v1h3.16v-1Zm0 3.03h-3.16v1h3.16v-1Zm6.07 24.47L20.48 3.18 29.17 2l4.33 31.98-8.69 1.18ZM21.6 4.04l4.06 30 6.71-.91-4.06-30.01-6.71.91v.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 6.88-3.13.42.13 1 3.14-.43-.14-.99Zm.41 3.01-3.13.42.13 1 3.14-.43-.14-1ZM9.38 30.78a1.84 1.84 0 1 1 0-3.68 1.84 1.84 0 0 1 0 3.68Zm0-2.69a.85.85 0 0 0-.84.84c0 .46.38.84.84.84.46 0 .84-.38.84-.84a.85.85 0 0 0-.84-.84Zm7.78 2.69a1.84 1.84 0 1 1 0-3.68 1.84 1.84 0 0 1 0 3.68Zm0-2.69a.85.85 0 0 0-.84.84c0 .46.38.84.84.84.46 0 .84-.38.84-.84a.85.85 0 0 0-.84-.84Zm11.09 1.87a1.84 1.84 0 1 1 0-3.68 1.84 1.84 0 0 1 0 3.68Zm0-2.69a.85.85 0 0 0-.84.84c0 .46.38.84.84.84.46 0 .84-.38.84-.84a.85.85 0 0 0-.84-.84Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-files"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 2h28.5v33.38H5z"
  })))));
};
export default SvgFiles;